import { useQuery } from 'react-query';
import { useApiGetNonAuthorized } from './useApi';
import { TenantInfo } from 'utils/types/tenantType';

export const useTenantInfo = (name: string) => {
  const fetchTenantInfo = useApiGetNonAuthorized(`/tenant/public/${name}`);

  return useQuery<TenantInfo>(['tenantInfo', name], fetchTenantInfo);
};
